import ScheduleIcon from "@mui/icons-material/Schedule";
import { Popover } from "@mui/material";
import { type FC, useCallback, useState } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import { FilterDropdown } from "~/components/UI/FilterDropdown";
import { EndsInFilterEnum } from "~/types/endsIn";
import {
  clearedEndsInCustom,
  type EndsInCustomFields,
  formatEndsInCustomLabel,
} from "~/utils/filters/endsInFilter";

import { EndsInCustomForm } from "./components/EndsInCustomForm";
import { endsInFilterOptions } from "./constants";

export const EndsInFilter: FC = () => {
  const { filters, updateFilters } = useFiltersScope();
  const [chipEl, setChipEl] = useState<HTMLButtonElement | null>(null);
  const [isCustomOpen, setIsCustomOpen] = useState(false);
  const isCustomApplied = filters.endsIn === EndsInFilterEnum.CUSTOM;

  const onChange = useCallback(
    (endsIn?: EndsInFilterEnum) => {
      if (endsIn === EndsInFilterEnum.CUSTOM) {
        setIsCustomOpen(true);
        return;
      }

      updateFilters({ endsIn, ...clearedEndsInCustom });
    },
    [updateFilters]
  );

  const closeCustom = useCallback(() => setIsCustomOpen(false), []);

  const applyCustom = useCallback(
    (value: EndsInCustomFields) => {
      updateFilters({ endsIn: EndsInFilterEnum.CUSTOM, ...value });
      setIsCustomOpen(false);
    },
    [updateFilters]
  );

  return (
    <>
      <FilterDropdown
        label="Ends in"
        icon={<ScheduleIcon fontSize="inherit" />}
        options={endsInFilterOptions}
        defaultValue={EndsInFilterEnum.ALL}
        value={
          isCustomOpen
            ? EndsInFilterEnum.CUSTOM
            : (filters.endsIn ?? EndsInFilterEnum.ALL)
        }
        valueLabel={isCustomApplied ? formatEndsInCustomLabel(filters) : null}
        chipRef={setChipEl}
        onChange={onChange}
      />
      <Popover
        anchorEl={chipEl}
        open={isCustomOpen}
        onClose={closeCustom}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <EndsInCustomForm
          initialValue={isCustomApplied ? filters : undefined}
          onApply={applyCustom}
          onCancel={closeCustom}
        />
      </Popover>
    </>
  );
};
